import omit from 'lodash/omit';

import { Preferences } from 'src/common/store/preferences/PreferencesState';
import { safelyGet } from 'src/common/utils/safelyGet';
import { InitialData } from 'src/types';

type OldPreferences = Preferences & {
  modelsBaseIriByDatabase: {
    [databaseId: string]: {
      [schemaName: string]: string | null;
    };
  };
};

// eslint-disable-next-line import/no-default-export
export default (data: InitialData) => {
  const oldPreferences: Partial<OldPreferences> = safelyGet(
    data,
    ['preferences'],
    {}
  );

  return {
    ...data,
    version: '5.7.1',
    preferences: omit(oldPreferences, 'modelsBaseIriByDatabase'),
  };
};
